import { render, staticRenderFns } from "./UserSetupAddContacts.vue?vue&type=template&id=6ae7e397&scoped=true&"
import script from "./UserSetupAddContacts.vue?vue&type=script&lang=js&"
export * from "./UserSetupAddContacts.vue?vue&type=script&lang=js&"
import style0 from "./UserSetupAddContacts.vue?vue&type=style&index=0&id=6ae7e397&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae7e397",
  null
  
)

export default component.exports